import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Icons as GridIcon } from "Components/AppGrid/shipeezi-new-grid";
import { FiTrash2 } from "react-icons/fi";
import { HiOutlinePlusCircle } from "react-icons/hi";

import Button from "../../../../../../../components/Form/Button";

const styles = makeStyles(() => ({
  button: {
    cursor: "pointer",
  },
  marginIcon: {
    marginRight: "8px",
  },

  deleteBorder: {
    border: "1px solid #F04438",
    "&:focus": {
      border: "1px solid #F04438",
    },
    "&:active": {
      border: "1px solid #F04438",
    },
    "&:hover": {
      border: "1px solid #F04438",
    },
  },
}));

export const StyledButton = styled(Button)(() => ({
  minWidth: "max-content",
}));

export const PlusIcon = styled(HiOutlinePlusCircle)(() => ({
  marginRight: "8px",
}));

export const DeleteIcon = styled(FiTrash2)(() => ({
  marginRight: "8px",
}));

export const ChangeStatusIcon = styled(GridIcon.status)(() => ({
  marginRight: "8px",
}));

export const NoWrapButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
  minWidth: "158px",
}));

export default styles;
